import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import Layout from './../layoutComponents/layout';
import FirstSection from '../layoutComponents/sections/FirstSection';

export default function SuccessPage() {
  return (
    <Layout>
      <div className="container max-w-4xl mx-auto text-center py-10 text-gray-800 my-16 lg:my-36">
        <div className="flex flex-col items-center text-center gap-8 bg-primary-50 rounded-xl shadow-sm p-8  border-dashed border-8 border-primary-500">
          <FaCheckCircle className="text-green-400 text-6xl" />
          <h2 className="text-4xl font-bold ">
            Tu formulario ha sido enviado{' '}
            <span className="text-green-500">con éxito</span>
          </h2>
          <p className="text-xl">
            Gracias por contactarnos. Nos pondremos en contacto contigo pronto.
          </p>
        </div>
      </div>
    </Layout>
  );
}
